import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Sessions ride on httpOnly cookies set by the backend; the SPA never stores tokens.
const handleResponseError = (loginPath) => (err) => {
  if (err.response?.status === 401 && !err.config.url.includes("/auth/") && window.location.pathname !== loginPath) {
    window.location.href = loginPath;
  }
  return Promise.reject(err);
};

export const api = axios.create({ baseURL: API, withCredentials: true });
api.interceptors.response.use((res) => res, handleResponseError("/login"));

export function apiError(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x.msg || JSON.stringify(x)).join(", ");
  return String(d);
}

export default api;

export const portalApi = axios.create({ baseURL: API, withCredentials: true });
portalApi.interceptors.response.use((res) => res, handleResponseError("/portal/login"));

export const imgSrc = (url) => {
  if (!url) return null;
  if (/^https?:\/\//i.test(url) || url.startsWith("data:")) return url;
  return `${process.env.REACT_APP_BACKEND_URL}${url}`;
};
